import React, { PureComponent } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import {
  TableCellWithSwitch,
  TableCellWithActionComponent,
  TableCellWithTextField,
} from '../common/PureItems'
import { hasAccess } from '../../utils/api'
import { Appcues } from '../../utils/constants'

class CloverItem extends PureComponent {
  onSave = () => {
    this.props.onSave(() => this.props.disableEdit())
    Appcues.track('Shop details for Clover settings saved')
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      this.props.onChange(key, isCheckBox ? event.target.checked : event.target.value)
    }

  render() {
    const { shop = {}, data = {}, editMode = false } = this.props

    return (
      <TableRow>
        <TableCell>{shop.name}</TableCell>
        <TableCellWithSwitch
          valueToRender={data.active ? 'Enabled' : 'Disabled'}
          checked={data.active}
          editMode={editMode}
          onChange={this.onChange('active', true)}
        />
        <TableCellWithTextField
          valueToRender={data.name || ''}
          value={data.name}
          editMode={editMode}
          onChange={this.onChange('name')}
        />
        <TableCellWithTextField
          valueToRender={data.username || ''}
          value={data.username}
          editMode={editMode}
          onChange={this.onChange('username')}
        />
        <TableCellWithTextField
          valueToRender={data.merchantId || ''}
          value={data.merchantId}
          editMode={editMode}
          onChange={this.onChange('merchantId')}
        />
        <TableCellWithTextField
          valueToRender={data.token || ''}
          value={data.token}
          editMode={editMode}
          onChange={this.onChange('token')}
        />
        {hasAccess() ? (
          <TableCellWithActionComponent
            onSave={this.onSave}
            onCancel={this.onCancel}
            onEdit={this.props.enableEdit}
            editMode={editMode}
          />
        ) : null}
      </TableRow>
    )
  }
}

export default CloverItem



// WEBPACK FOOTER //
// ./src/components/Clover/CloverItem.js